import api from '../../../api/mdtravail/_societes'
import store from '@/store'


const state = () => ({
    societe: null,
    societes: [],
    groupeParametrageVM: [],
    importGroupeParametrageVM: [],
    categoriesVM :[],
    selectedSousCategoryVM: null,
    parametrageVisiteMedicaleCheck: null,
    visitesMedicales: null,
    latestVisiteMedicaleAnnuelle: null,
    latestVisiteStats: [],
    currentProgrammationLists: [],
    societeVisitesMedicales: [],
    postes : [],
    visiteDoneStats: [],
    visiteMedicaleResults: [],
    postesSelect: [],
    pendingVisitesForTechLabo:[]
})

// getters
const getters = {
        societe: (state) => {
            return state.societe
        },

        /**
         * Liste de toutes les sociétés
         */
        societes: (state) => {
            return state.societes
        },

        departements:(state) =>{
            return state.departements
        },
        postes: (state) => {
            return state.postes
        },
        groupeParametrageVM: (state) => {
            return state.groupeParametrageVM
        },
        importGroupeParametrageVM: (state) => {
            return state.importGroupeParametrageVM
        },
        categoriesVM: (state) =>{
            return state.categoriesVM
        },
        selectedSousCategoryVM: (state)=>{
            return state.selectedSousCategoryVM
        },
        parametrageVisiteMedicaleCheck: (state)=>{
            return state.parametrageVisiteMedicaleCheck
        },
        visitesMedicales: (state) => {
            return state.visitesMedicales
        },
        latestVisiteStats: (state) => {
            return state.latestVisiteStats
        },
        visiteDoneStats: (state) =>{
            return state.visiteDoneStats
        },

        latestVisiteMedicaleAnnuelle: (state) => {
            return state.latestVisiteMedicaleAnnuelle
        },
        currentProgrammationLists: (state) => {
            return state.currentProgrammationLists
        },
        societeVisitesMedicales: (state) => {
            return state.societeVisitesMedicales
        },
        visiteMedicaleResults: (state) => {
            return state.visiteMedicaleResults
        },
        postesSelect: (state) => {
            return state.postesSelect
        },
        pendingVisitesForTechLabo: (state) => {
            return state.pendingVisitesForTechLabo
        }

    }
    // mutations
const mutations = {
    
    SET_GROUPE_PARAMETRAGE_VM(state, groupeParametrageVM){
        state.groupeParametrageVM = groupeParametrageVM;

    },
    SET_IMPORT_GROUPE_PARAMETRAGE_VM(state,importGroupeParametrageVM){
        state.importGroupeParametrageVM = importGroupeParametrageVM
    },
    SET_SOCIETE(state, societe) {
        state.societe = societe;
    },

    SET_SOCIETES(state, societes) {
        state.societes = societes;
    },

    SET_DEPARTEMENTS(state, departements) {
        state.departements = departements
    },
    SET_POSTES(state,postes){
        state.postes = postes 
    },
    SET_CATEGORIES_VM(state, categoriesVM){
        state.categoriesVM = categoriesVM
    },
    SET_SELECTED_SOUS_CATEGORIES_VM(state,selectedSousCategoryVM){
        state.selectedSousCategoryVM = selectedSousCategoryVM
    },
    SET_PARAMETRAGE_VM_CHECK(state,parametrageVisiteMedicaleCheck){
        state.parametrageVisiteMedicaleCheck = parametrageVisiteMedicaleCheck
    },
    SET_VISITES_MEDICALES(state, visitesMedicales){
        state.visitesMedicales = visitesMedicales
    },
    SET_LATEST_VISITE_STATS(state,latestVisiteStats){
        state.latestVisiteStats = latestVisiteStats
    },
    SET_VISITE_DONE_STATS(state, visiteDoneStats){
        state.visiteDoneStats = visiteDoneStats
    },
    SET_LATEST_VISITE_MEDICALE_ANNUELLE(state, latestVisiteMedicaleAnnuelle){
        state.latestVisiteMedicaleAnnuelle = latestVisiteMedicaleAnnuelle
    },
    SET_CURRENT_PROGRAMMATION_LIST(state, currentProgrammationLists){
        state.currentProgrammationLists = currentProgrammationLists
    },
    SET_SOCIETE_VISITES_MEDICALES(state,societeVisitesMedicales){
        state.societeVisitesMedicales = societeVisitesMedicales
    },
    SET_VISITE_MEDICALE_RESULTS(state,visiteMedicaleResults){
        state.visiteMedicaleResults = visiteMedicaleResults
    },
    SET_POSTES_SELECT(state, postesSelect){
        state.postesSelect = postesSelect
    },
    SET_PENDING_VISITES_FOR_TECH_LABO(state, pendingVisitesForTechLabo){
        state.pendingVisitesForTechLabo = pendingVisitesForTechLabo
    }



}

// actions
const actions = {
    getCertifications({ commit }) {
        return new Promise((resolve, reject) => {

            api.getCertifications().then(
                response => {
                    commit
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    getTypesContrats({ commit }) {
        return new Promise((resolve, reject) => {

            api.getTypesContrats().then(
                response => {
                    commit
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    getSecteurs({ commit }) {
        return new Promise((resolve, reject) => {

            api.getSecteurs().then(
                response => {
                    commit
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getSociete({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getSociete(id).then(
                response => {
                    commit('SET_SOCIETE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    // enregistrer une societé
    saveSociete({ commit }, data) {
        return new Promise((resolve, reject) => {
            console.log('savinggg', data)
            api.saveSociete(data).then(
                response => {
                    commit
                    
                    resolve(response);

                }, error => {

                    reject(error);
                }
            )
        })

    },

    // liste des societés
    getSocietes({ commit }) {
        return new Promise((resolve, reject) => {
            api.getSocietes().then(
                response => {
                    commit('SET_SOCIETES', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getDepartements({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDepartements().then(
                response => {
                    commit("SET_DEPARTEMENTS", response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    getPostes({commit},id){
        return new Promise((resolve, reject) => {
            api.getPostes(id).then(
                response => {
                    commit("SET_POSTES", response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    saveTravailleur({ commit }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.saveTravailleur(id, data).then(
                response => {
                    commit
                    console.log("REP: ", response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteContrat({ dispatch },  id) {
        return new Promise((resolve, reject) => {
            api.deleteContrat( id ).then(
                response => {
                    dispatch('getSociete', id )
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    addContrat({ dispatch, commit },  {data , id}) {
        return new Promise((resolve, reject) => {
            api.addContrat( data, id ).then(
                response => {
                    commit
                    dispatch('getSociete', id )
                    resolve(response)
                }, error => {
                    reject(error)

                }
            )
        })
    },

    ajouterGroupeParametrageVM({dispatch},data){
        return new Promise((resolve,reject) => {
            api.ajouterGroupeParametrageVM(data).then(
                response =>{
                    dispatch('getGroupeParametrageVM',data.societe_id)
                    resolve(response)
                },error =>{
                    reject(error)
                }
            )
        })
    },
    getGroupeParametrageVM({commit},id){
        return new Promise((resolve, reject) => {
            api.getGroupeParametrageVM(id).then(
                response => {
                    commit('SET_GROUPE_PARAMETRAGE_VM',response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getGroupeToImportParametrageVM({commit},id){
        return new Promise((resolve, reject) => {
            api.getGroupeParametrageVM(id).then(
                response => {
                    commit('SET_IMPORT_GROUPE_PARAMETRAGE_VM',response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    editGroupeParametrageVM({dispatch},{id,data}){
        return new Promise((resolve, reject) =>{
            api.editGroupeParametrageVM(id,data).then(
                response => {
                    dispatch('getGroupeParametrageVM',data.societe_id)
                    resolve(response)
                } , error =>{
                    reject(error)
                }
            )
        })
    },
    deleteGroupeParametrageVM({dispatch},{societe_id,groupe_id}){
        return new Promise((resolve,reject) =>{
            api.deleteGroupeParametrageVM(societe_id,groupe_id).then(
                response => {
                    dispatch('getGroupeParametrageVM',societe_id)
                    resolve(response)
                } , error => {
                    reject(error)
                }
            )
        })
    },
    getCategoriesVisitesMedicales({commit}){
        return new Promise((resolve,reject) => {
            api.getCategoriesVisitesMedicales().then(
                response => {
                    commit("SET_CATEGORIES_VM",response)
                    resolve(response)
                } , error =>{
                    reject(error)
                }
            )
        })
    },

    getSingleSubCategoryVM({commit}, id){
        return new Promise((resolve,reject)=>{
            api.getSingleSubCategoryVM(id).then(
                response => {
                    commit("SET_SELECTED_SOUS_CATEGORIES_VM",response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    checkIfVisiteMedicalesParamIsset({commit}){
        return new Promise((resolve, reject) => {
            api.checkIfVisiteMedicalesParamIsset().then(
                response => {
                    commit("SET_PARAMETRAGE_VM_CHECK",response)
                    resolve(response)
                }, error =>{
                    reject(error)
                }
            )
        })
    },
    programVisiteMedicale({dispatch},data){
        return new Promise((resolve, reject) => {
            api.programVisiteMedicale(data).then(
                response => {
                    dispatch('getVisitesMedicales',data.sous_categorie_id)
                    //dispatch('getVisitesMedicales',data.sous_categorie_id)
                    // commit("SET_PARAMETRAGE_VM_CHECK",response)
                    resolve(response)
                }, error =>{
                    reject(error)
                }
            )
        })
    },
    getVisitesMedicales({commit},sous_categorie_id){
        return new Promise((resolve,reject) => {
            api.getVisitesMedicales(sous_categorie_id).then(
                response => {
                    resolve(response)
                    commit('SET_VISITES_MEDICALES',response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getSocieteVisitesMedicales({commit},{sous_categorie_id,societe_id,date}){
        return new Promise((resolve,reject) => {
            api.searchVisitesMedicales(sous_categorie_id,societe_id,date).then(
                response => {
                    resolve(response)
                    commit('SET_SOCIETE_VISITES_MEDICALES',response)
                }, error => {
                    reject(error)
                }
            )
            
        })
    },
    searchVisitesMedicales({commit},{sous_categorie_id,societe_id,date}){
        return new Promise((resolve,reject) => {
            api.searchVisitesMedicales(sous_categorie_id,societe_id,date).then(
                response => {
                    resolve(response)
                    commit('SET_VISITES_MEDICALES',response)
                }, error => {
                    reject(error)
                }
            )
            
        })
    },

    initVisitesMedicalesProgrammation({commit}, {societe_id,data}){
        return new Promise((resolve,reject) =>{
            api.initVisitesMedicalesProgrammation(societe_id,data).then(
                response => {
                    resolve(response)
                    commit
                }, error=> {
                    reject(error)
                }
            )
        })
    },
    getSocieteCurrentVisiteMedicale({commit},$societe_id){
        return new Promise((resolve,reject) =>{
            api.getSocieteCurrentVisiteMedicale($societe_id).then(
                response => {
                    resolve(response)
                    commit("SET_LATEST_VISITE_MEDICALE_ANNUELLE",response)
                }, error=> {
                    reject(error)
                }
            )
        }) 
    },
    getSocieteVisiteMedicaleStats({commit},visite_id){
        return new Promise((resolve,reject) =>{
            api.getSocieteVisiteMedicaleStats(visite_id).then(
                response =>{
                    resolve(response)
                    commit("SET_LATEST_VISITE_STATS",response)
                }, error=>{
                    reject(error)
                }
            )
        })
    },
    getSocieteVisiteMedicaleStatsDone({commit},visite_id){
        return new Promise((resolve,reject) =>{
            api.getSocieteVisiteMedicaleStatsDone(visite_id).then(
                response =>{
                    resolve(response)
                    commit("SET_VISITE_DONE_STATS",response)
                }, error=>{
                    reject(error)
                }
            )
        })
    },
    getProgrammationsVisitesMedicales({commit},visite_id){
        return new Promise((resolve,reject) =>{
            api.getProgrammationsVisitesMedicales(visite_id).then(
                response =>{
                    resolve(response)
                    commit("SET_CURRENT_PROGRAMMATION_LIST",response)
                },error =>{
                    reject(error)
                }
             )
        })
    },
    searchProgrammationsVisitesMedicales({commit},{visite_id,word_filter,departement_id,poste}){
        return new Promise((resolve,reject) =>{
            api.searchProgrammationsVisitesMedicales(visite_id,word_filter,departement_id,poste).then(
                response =>{
                    resolve(response)
                    commit("SET_CURRENT_PROGRAMMATION_LIST",response)
                },error =>{
                    reject(error)
                }
             )
        })
    },
    importGlobalGroupesInSociete({dispatch},{id,data}){
        return new Promise((resolve,reject) =>{
            api.importGlobalGroupesInSociete(id,data).then(
                response =>{
                    resolve(response)
                    dispatch("getGroupeParametrageVM",id)
                }, error =>{
                    reject(error)
                }
            )
        })
    }, 
    checkGroupeForEmployees({dispatch},{id,data}){
        return new Promise((resolve,reject) =>{
            api.checkGroupeForEmployees(id,data).then(
                response => {
                    resolve(response)
                    dispatch("getSocieteVisiteMedicaleStats",id)

                }, error => {
                    reject(error)
                }
            )
        })
    },
    getVisiteMedicaleResults({commit},id){
        return new Promise((resolve,reject) =>{
            api.getVisiteMedicaleResults(id).then(
                response => {
                    resolve(response)
                    commit("SET_VISITE_MEDICALE_RESULTS",response)
                    //dispatch("getSocieteVisiteMedicaleStats",id)

                }, error => {
                    reject(error)
                }
            )
        })
    },
    uploadFileVisiteMedicale({dispatch},{id,data} ){
        return new Promise((resolve,reject) =>{
            api.uploadFileVisiteMedicale(id,data).then(
                response => {
                    resolve(response)
                    if(store.getters['activeRole'].nom == 'ROLE_MEDECIN_TRAVAIL'){
                        dispatch("getVisiteMedicaleResults",response.visite_medicale_id)
                    } else if (store.getters['activeRole'].nom == 'ROLE_TECH_SUP_LABO'){
                        dispatch("getProgrammationsForTechLabo",response.visite_medicale_id)
                    } else{
                        
                        
                        let my_user = store.getters['authInfo'].user.id
                        dispatch("getVisitesProgrammationsInfirmier",{ visite_id:response.visite_medicale_id,user_id: my_user})                        
                    }
                    
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getPostesSelect({commit}){
        return new Promise((resolve,reject) =>{
            api.getPostesSelect().then(
                response => {
                    resolve(response),
                    commit('SET_POSTES_SELECT',response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getPendingVisitesForTechLabo({commit}){
        return new Promise((resolve,reject) =>{
            api.getPendingVisitesForTechLabo().then(
                response => {
                    resolve(response),
                    commit('SET_PENDING_VISITES_FOR_TECH_LABO',response)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    getProgrammationsForTechLabo({commit},visite_id){
        return new Promise((resolve,reject) => {
            api.getProgrammationsForTechLabo(visite_id).then(
                response =>{
                    resolve(response)
                    commit('SET_VISITE_MEDICALE_RESULTS',response)
                }, error =>{
                    reject(error)
                }
            )
        })
    },
    sendVisitesAnalysesFiles({dispatch},{visite_id,analyse_id,data}){
        return new Promise((resolve,reject) => {
            api.sendVisitesAnalysesFiles(visite_id,analyse_id,data).then(
                response => {
                    resolve(response)
                    dispatch("getProgrammationsForTechLabo", visite_id)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getVisitesForInfirmier({commit},user_id){
        return new Promise((resolve,reject) => {
            api.getVisitesForInfirmier(user_id).then(
                response => {
                    resolve(response)
                    commit('SET_PENDING_VISITES_FOR_TECH_LABO',response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getVisitesProgrammationsInfirmier({commit},{visite_id,user_id}){
        return new Promise((resolve,reject) =>{
            api.getVisitesProgrammationsInfirmier(visite_id,user_id).then(
                response => {
                    resolve(response)
                    commit('SET_VISITE_MEDICALE_RESULTS',response)
                }, error => {
                    reject(error)
                }
            )
        })
    }








}



export default {
    state,
    getters,
    actions,
    mutations
}